import { render, staticRenderFns } from "./AvaliacaoPsicossocialPerguntas.vue?vue&type=template&id=dfb4a802&"
import script from "./AvaliacaoPsicossocialPerguntas.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoPsicossocialPerguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports